import React from 'react';

const Foot = () => {

	return (
		<p> thrift-savanna &copy; 2022 </p>
	)

}

export default Foot;